import React, { useState } from 'react'
import './styles.scss'

export const InsetQuestion = ({
  id = 'InfoBox',
  question,
  children
}: {
  id?: string
  question: string | React.ReactChild
  children: React.ReactChild
}) => {
  const [isOpen, setOpen] = useState(false)
  return (
    <div className={'InsetQuestion ' + (isOpen ? 'open' : '')}>
      <div className='sidewrapper'>
        {/* <div className='qline' /> */}

        <button
          className='question'
          onClick={() => {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'Interactions',
              event_action: 'click',
              event_label: `open-box: ` + id
            })

            setOpen(!isOpen)
          }}
        >
          <span>{question}</span>
          <div className='carnet' />{' '}
        </button>
      </div>
      <div className={'contentwrapper'}>
        <div className={'content'}>{children}</div>
      </div>
    </div>
  )
}
